const ExportSystemSelectModal = ({ onClose, onSelect }) => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        backdropFilter: "blur(2px)",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: 440,
          backgroundColor: "#ffffff",
          borderRadius: 16,
          padding: "32px",
          boxShadow:
            "0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 24px rgba(0, 0, 0, 0.1)",
          fontFamily:
            "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          animation: "fadeIn 0.2s ease-out",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ marginBottom: 28 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 8,
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                backgroundColor: "#1e40af",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: 600,
                fontSize: 18,
              }}
            >
              📤
            </div>
            <h2
              style={{
                margin: 0,
                fontSize: 22,
                fontWeight: 700,
                color: "#1e293b",
                letterSpacing: "-0.01em",
              }}
            >
              Välj lönesystem
            </h2>
          </div>
          <p
            style={{
              marginTop: 8,
              fontSize: 15,
              color: "#64748b",
              lineHeight: 1.5,
              marginLeft: 52,
            }}
          >
            Välj vilket lönesystem du vill exportera löneunderlaget till.
          </p>
        </div>

        {/* Options */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            marginBottom: 28,
          }}
        >
          {/* Fortnox */}
          <button
            onClick={() => onSelect("fortnox")}
            style={{
              width: "100%",
              padding: "18px 20px",
              borderRadius: 12,
              border: "1px solid #e2e8f0",
              backgroundColor: "#ffffff",
              cursor: "pointer",
              fontSize: 16,
              fontWeight: 600,
              textAlign: "left",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              transition: "all 0.2s ease",
              color: "#1e293b",
              position: "relative",
              overflow: "hidden",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f8fafc";
              e.currentTarget.style.borderColor = "#3b82f6";
              e.currentTarget.style.boxShadow =
                "0 0 0 3px rgba(59, 130, 246, 0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.borderColor = "#e2e8f0";
              e.currentTarget.style.boxShadow = "none";
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = "scale(0.99)";
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  backgroundColor: "#eff6ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#1d4ed8",
                  fontWeight: 600,
                }}
              >
                F
              </div>
              <span>Fortnox</span>
            </div>
            <span
              style={{
                color: "#64748b",
                fontSize: 14,
                backgroundColor: "#f1f5f9",
                padding: "4px 10px",
                borderRadius: 6,
                fontWeight: 500,
              }}
            >
              PAXml-export
            </span>
          </button>

          {/* Visma – Coming soon (same as Kontek) */}
          <div
            style={{
              width: "100%",
              padding: "18px 20px",
              borderRadius: 12,
              border: "1px dashed #e2e8f0",
              backgroundColor: "#f8fafc",
              fontSize: 16,
              fontWeight: 600,
              textAlign: "left",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#94a3b8",
              position: "relative",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  backgroundColor: "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#94a3b8",
                  fontWeight: 600,
                }}
              >
                V
              </div>
              <span>Visma Lön</span>
            </div>
            <span
              style={{
                color: "#94a3b8",
                fontSize: 12,
                backgroundColor: "#f1f5f9",
                padding: "4px 10px",
                borderRadius: 6,
                fontWeight: 500,
                border: "1px solid #e2e8f0",
              }}
            >
              Kommer snart
            </span>
          </div>

          {/* Kontek – Coming soon */}
          <div
            style={{
              width: "100%",
              padding: "18px 20px",
              borderRadius: 12,
              border: "1px dashed #e2e8f0",
              backgroundColor: "#f8fafc",
              fontSize: 16,
              fontWeight: 600,
              textAlign: "left",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#94a3b8",
              position: "relative",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 8,
                  backgroundColor: "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#94a3b8",
                  fontWeight: 600,
                }}
              >
                K
              </div>
              <span>Kontek</span>
            </div>
            <span
              style={{
                color: "#94a3b8",
                fontSize: 12,
                backgroundColor: "#f1f5f9",
                padding: "4px 10px",
                borderRadius: 6,
                fontWeight: 500,
                border: "1px solid #e2e8f0",
              }}
            >
              Kommer snart
            </span>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingTop: 20,
            borderTop: "1px solid #f1f5f9",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "12px 24px",
              borderRadius: 10,
              border: "1px solid #e2e8f0",
              backgroundColor: "#ffffff",
              color: "#64748b",
              fontSize: 15,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f8fafc";
              e.currentTarget.style.borderColor = "#94a3b8";
              e.currentTarget.style.color = "#475569";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.borderColor = "#e2e8f0";
              e.currentTarget.style.color = "#64748b";
            }}
          >
            Avbryt
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportSystemSelectModal;
